export const FAVORITE_SPORTS = [
  'Tennis',
  'Basketball',
  'Badminton',
  'Baseball',
  'Padel',
  'Biking',
  'Pickleball',
  'Bowling',
  'Squash',
  'Boxing',
  'Table Tennis',
  'Cricket',
  'Football',
  'Field Hockey',
  'Golf',
  'Pool',
  'Rugby',
  'Snooker',
  'Swimming',
  'Volleyball',
  'Yoga',
  'Fitness',
  'Chess',
] as const;
